import type { TOC } from '@ember/component/template-only';
import ChangesetBasicRadio, {
  type S as ChangesetBasicRadioSig
} from '../basic-radio.gts';

interface S {
  Element: HTMLDivElement;
  Args: Pick<
    ChangesetBasicRadioSig['Args'],
    | 'changeset'
    | 'propertyName'
    | 'value'
    | 'label'
    | 'translationKey'
    | 'disabled'
    | 'dataTestValue'
    | 'isReadOnly'
  >;
}

const ChangesetBasicRadioGroupFieldRadio: TOC<S> = <template>
  <div class='field' ...attributes>
    <ChangesetBasicRadio
      @changeset={{@changeset}}
      @propertyName={{@propertyName}}
      @value={{@value}}
      @label={{@label}}
      @translationKey={{@translationKey}}
      @disabled={{@disabled}}
      @dataTestValue={{@dataTestValue}}
      @isReadOnly={{@isReadOnly}}
    />
  </div>
</template>;

export default ChangesetBasicRadioGroupFieldRadio;
